<script>
const profile = "prod";
const apiUrl = "https://www.tofaauto.com";
// const apiUrl = "http://8.134.184.9:8160";
// const apiUrl = "http://192.168.31.10:8040";

const env = {
    dev: {
        host: "http://127.0.0.1",
        apiUrl: "http://127.0.0.1:8040",
        uploadUrl: "http://192.168.31.10:8040/upload/imageNew",
    },
    prod: {
        host: "https://www.tofaauto.com",
        apiUrl: "https://www.tofaauto.com",
        uploadUrl: "https://www.tofaauto.com/upload/imageNew",
        // host: "http://8.134.184.9:8160",
        // apiUrl: "http://8.134.184.9:8160",
        // uploadUrl: "http://8.134.184.9:8160/upload/imageNew",
    },
};

export default {
    apiUrl: apiUrl,
    env: env[profile],
};
</script>



// WEBPACK FOOTER //
// src/common/Global.vue